import * as TrackingDescriptionAPI from 'api/trackingDescription';
import { call, put, select } from 'redux-saga/effects';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { actionCreators as trackingAC, getIsLoaded } from 'store/trackingDescription';

export function* loadTrackingDescriptions() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkSaveRequestError());
	}

	const isLoaded = yield select(getIsLoaded);
	if (isLoaded) {
		return false;
	}

	try {
		const descriptions = yield call(TrackingDescriptionAPI.fetchTrackingDescriptions);
		yield put(trackingAC.doRequestDescriptionsSuccess(descriptions));
	} catch (e) {
		yield put(trackingAC.doRequestDescriptionsFailure(e));
	}
}
